'use strict';

var _extends = Object.assign || function (target) {
  for (var source, i = 1; i < arguments.length; i++) {
    for (var key in source = arguments[i], source) {
      Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
    }
  }

  return target;
},
    _createClass = function () {
  function defineProperties(target, props) {
    for (var descriptor, i = 0; i < props.length; i++) {
      descriptor = props[i], descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 'value' in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), Constructor;
  };
}(),
    _react = require('react'),
    _react2 = _interopRequireDefault(_react),
    _vstui = require('@vitalsource/vstui');

Object.defineProperty(exports, '__esModule', {
  value: !0
});

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) throw new TypeError('Cannot call a class as a function');
}

function _possibleConstructorReturn(self, call) {
  if (!self) throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called');
  return call && ('object' == typeof call || 'function' == typeof call) ? call : self;
}

function _inherits(subClass, superClass) {
  if ('function' != typeof superClass && null !== superClass) throw new TypeError('Super expression must either be null or a function, not ' + typeof superClass);
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: !1,
      writable: !0,
      configurable: !0
    }
  }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
}

var ThumbsDown = function (_PureComponent) {
  function ThumbsDown() {
    return _classCallCheck(this, ThumbsDown), _possibleConstructorReturn(this, (ThumbsDown.__proto__ || Object.getPrototypeOf(ThumbsDown)).apply(this, arguments));
  }

  return _inherits(ThumbsDown, _PureComponent), _createClass(ThumbsDown, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_vstui.Icon, _extends({}, this.props, {
        height: 14,
        width: 13
      }), _react2.default.createElement('path', {
        d: 'M10.465 1.1C9.311.89 9.341.736 7.382.239 6.119-.082 4.068-.047 2.776.157c-1.017.16-1.52.688-1.562 1.09-.054.519.498.674.498.674s-1.233.05-1.362.87C.219 3.618.824 3.84.824 3.84S0 4.08 0 4.85c0 .784.837 1.036.837 1.036S.1 5.988.1 6.748c0 .573.397.823.964 1.022.752.266 3.813.344 3.813.344s.588.504.042 1.218c0 0-1.896 2.737-.59 4.119 0 0 .884 1.008 1.473.294 0 0 .13-2.341 1.47-3.615 1.278-1.213 2.32-2.644 3.303-3.857a.503.503 0 0 1 .376-.184l1.562-.044A.501.501 0 0 0 13 5.543V1.838a.5.5 0 0 0-.465-.501 19.17 19.17 0 0 1-2.07-.236'
      }));
    }
  }]), ThumbsDown;
}(_react.PureComponent);

ThumbsDown.displayName = 'ThumbsDown', ThumbsDown.vstuiName = 'Icon', exports.default = ThumbsDown;